import { Injectable } from '@angular/core';

@Injectable()
export class SharedService {
  public requiresPaymentRunUpdateMessage: boolean = false;
  public isUpdatingPaymentRunMessage: boolean = false;
  public canEditProduct: boolean = false;
  public businessId: string = '';
  public showAVC: boolean = false;
  public defaultCurrencyCode: string = 'ZAR';
  public defaultCurrencySymbol: string = 'R';
  public navigateToPage: string = '';
  public isFromLegalEntities: boolean = false;
  public isEmployeeHasBusinessPermission: boolean = false;
  public payrollChangesDocumentFileName: string = '';
  public isEmployeeDetailsLoading: boolean = false;
  public isLegalEntityTypeBusiness: boolean = false;
  public legalEntityTypeBusinessId: string = 'ba67c428-d1fb-4f66-9ad0-a2da3df4dc7c';
  public isToLoadTODO: boolean = true;
  public isTODO: boolean = false;
  public isAdminDashboard: boolean = false;
  public isFromTODO: boolean = false;
  public viewUsersCurrentPage: number = 1;
  public newEditedUsersCurrentPage: number = 1;

  public pendingBulkUpload: boolean = false;
  public pendingErrorsAndWarnings: boolean = false;
  public pendingPayrollRun: boolean = false;
  public bulkImportInviteHistoryId: string | null = null;

  public showAcknowledgePaymentRunStatusMessage: boolean = false;
  public acknowledgePaymentRunStatusMessage: string;
  // Live SignalR progress (0-100) for the acknowledge / paid-by-EFT jobs; drives the progress bar.
  public acknowledgePaymentRunPercent: number = 0;
  public showAcknowledgePaymentRunPaidByEFTStatusMessage: boolean = false;
  public acknowledgePaymentRunPaidByEFTStatusMessage: string;
  public acknowledgePaymentRunPaidByEFTPercent: number = 0;

  public forgotPasscodeDialingCode: string;
  public forgotPasscodeMobileNumber: string;
  public forgotPasscodeIsUserEmailVerified: boolean;
  public forgotPasscodeIsOTP: boolean;
  public forgotPasscodeResendOTPAfter: number;
  public selectedBenchmarks: any;

  allowedDomains = ['11fifty', 'hayrick'];
  allowedSubDomains = ['business-portal-dev', 'business-portal-stg', 'business-portal'  , 'hayrick-portal-dev', 'hayrick-portal-stg', 'hayrick-portal', 'admin-dev', 'admin-stg', 'admin'];

  constructor() {}

  /*
   * This method rounds a number to a given precision.
   */
  roundTo(number: number, precision: number) {
    if (precision < 0) {
      let factor = Math.pow(10, precision);
      return Math.round(number * factor) / factor;
    } else return +(Math.round(Number(number + 'e+' + precision)) + 'e-' + precision);
  }

  /*
   * This method returns the extension by the mime type.
   */
  getExtensionFromMimeType(mimeType) {
    var extension = '';

    if (mimeType) {
      switch (mimeType) {
        case 'application/pdf':
          extension = '.pdf';
          break;
        case 'application/vnd.ms-excel':
          extension = '.xls';
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          extension = '.xlsx';
          break;
        case 'application/vnd.ms-excel.sheet.macroenabled.12':
          extension = '.xlsm';
          break;
        case 'application/msword':
          extension = '.doc';
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          extension = '.docx';
          break;
        case 'text/html':
          extension = '.html';
          break;
        case 'image/jpeg':
          extension = '.jpeg';
          break;
        case 'image/png':
          extension = '.png';
          break;
        case 'application/zip':
          extension = '.zip';
          break;
      }
    }

    return extension;
  }

  /*
   * This method high lights the edited cells of a data grid.
   */
  highlightEditableCells (e) {
    if (e.rowType === "data" && e.row.isEditing && e.column.allowEditing) {
      e.cellElement.classList.add("editable-cell");
    }
  }

  /*
   * This method returns the sub domain name from the current url.
   */
  getSubDomain(): string {
    const hostname = window.location.hostname; // e.g., client1.example.com
    const parts = hostname.split('.');

    // Assuming your domain is like client1.example.com
    if (parts.length > 2) {
      var domain = parts[1];
      var subdomain = parts[0];

      if(this.allowedDomains.includes(domain) && this.allowedSubDomains.includes(subdomain)) {
        if(domain === '11fifty') {
          return '11fifty';
        }
        return 'default';
      }

      return subdomain;
    }

    return 'default'; // No subdomain present
  }


  /**
   * Formatter to format the country
   * @param country
   * @returns
   */
  formatCountry = (country: any) => {
    if (!country || !country.description) return '';
    return country.description
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };
}
